import React, {useEffect} from 'react';
import {PauseIcon, RatingNumber} from 'components';
import {Audio} from 'interfaces';

import {PlayIcon} from './Icons/PlayIcon';

type AudioItemProps = Audio & {
  _id: string;
  isPlaying: boolean;
  onPlay: (id: string) => void;
  onClick: (id: string) => void;
};

export const DirectoryAudioItem: React.FC<AudioItemProps> = ({
  title,
  audio,
  coverImageThumbnailUrl,
  isPlaying,
  _id,
  providerId,
  rating = 4.5,
  onPlay,
  onClick,
}) => {
  const audioRef = React.useRef<HTMLAudioElement>(null);

  useEffect(() => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }

    return () => {
      if (audioRef.current) audioRef.current.pause();
    };
  }, [isPlaying]);

  const handleAudioPlay = () => {
    onPlay(_id);
  };

  const handleAudioClick = () => {
    onClick(_id);
  };

  return (
    <div className="flex flex-col gap-5 w-[195px] flex-shrink-0 p-1">
      <audio ref={audioRef} src={audio?.audioUrl} />
      <div className="relative group">
        <img
          loading="lazy"
          src={coverImageThumbnailUrl}
          alt={title}
          className={`object-contain shrink-0 cursor-pointer self-stretch my-auto rounded-3xl aspect-square w-full ${
            isPlaying ? 'opacity-0' : ''
          } group-hover:opacity-0`}
        />
        <div
          className={`absolute inset-0 flex items-center cursor-pointer justify-center bg-black bg-opacity-70 rounded-3xl ${
            isPlaying ? 'opacity-100' : 'opacity-0'
          } group-hover:opacity-100`}
          onClick={handleAudioPlay}
        >
          {isPlaying ? <PauseIcon /> : <PlayIcon />}
        </div>
      </div>

      <button
        className="flex flex-col gap-1 text-left w-full"
        onClick={handleAudioClick}
      >
        <h2 className="text-sm font-medium text-black line-clamp-2 cursor-pointer">
          {title}
        </h2>
        <p className="mt-0 text-[13px] text-black">by {providerId?.fullName}</p>
        <RatingNumber rating={rating} />
      </button>
    </div>
  );
};
